<template>
	<div class="row">
		<!-- 左侧展示列，根据不同模式自适应宽度 -->
		<div :class="viewMode === 'list' ? 'col col-md-2 col-sm-3' : 'col col-md-3 col-sm-4'">
			<!-- 展现形式切换按钮组 -->
			<div class="mb-2">
				<b-button-group size="sm" class="w-100">
					<b-button 
						:variant="viewMode === 'list' ? 'primary' : 'outline-primary'" 
						@click="viewMode = 'list'"
						style="font-size: 11px; padding: 4px 6px;"
					>
						列表模式
					</b-button>
					<b-button 
						:variant="viewMode === 'table' ? 'primary' : 'outline-primary'" 
						@click="viewMode = 'table'"
						style="font-size: 11px; padding: 4px 6px;"
					>
						表格模式
					</b-button>
				</b-button-group>
			</div>
			
			<!-- 列表模式 -->
			<div v-if="viewMode === 'list'">
				<PopularStock @p_show_kline="show_kline"></PopularStock>
			</div>
			
			<!-- 表格模式 -->
			<div v-else-if="viewMode === 'table'">
				<div>
					<b-form-datepicker 
						size="sm" 
						:date-disabled-fn="dateDisabled" 
						@context="onDatePicked" 
						v-model="date1" 
						class="mb-1" 
						today-button 
						close-button 
						locale="zh"
					></b-form-datepicker>
				</div>
				<PopularTable 
					:items="items" 
					:isBusy="isBusy" 
					@show-kline="show_kline"
				/>
			</div>
		</div>
		
		<!-- 右侧图表及代码输入 -->
		<div :class="viewMode === 'list' ? 'col col-md-10 col-sm-9' : 'col col-md-9 col-sm-8'">
			<StockMultiChart :symbol_code="symbol_code" :symbol_name="symbol_name" :chart_width="'1000px'"></StockMultiChart>
			
			<div role="group" class="mt-2 d-flex align-items-center">
				<label for="input-symbol_code" class="mb-0 mr-2" style="font-size: 12px; color: var(--text-muted);">股票代码:</label>
				<b-form-input
					id="input-symbol_code"
					v-model="symbol_code"
					:state="nameState"
					aria-describedby="input-live-feedback"
					placeholder="6位股票代码"
					trim
					style="width: 200px;"
					size="sm"
				></b-form-input>
				<b-form-invalid-feedback id="input-live-feedback" class="ml-2">
					请输入6位股票代码
				</b-form-invalid-feedback>
			</div>
		</div>
	</div>
</template>

<script>
	import PopularStock from 'components/sentiment/PopularStock.vue'
	import StockMultiChart from 'components/stock/StockMultiChart.vue'
	import PopularTable from 'components/sentiment/PopularTable.vue'
	import { request_zzquant } from "network/request.js"
	
	export default {
		name: "SentimentPopular",
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
			return {
				viewMode: 'list', // 'list' | 'table'
				date1: today,
				symbol_name: "",
				symbol_code: "600196",
				isBusy: true,
				items: []
			}
		},
		computed: {
			nameState() {
				return this.symbol_code.length === 6;
			}
		},
		watch: {
			viewMode(newMode) {
				if (newMode === 'table' && this.items.length === 0) {
					this.load_popular_table_data();
				}
			}
		},
		components: {
			PopularStock,
			StockMultiChart,
			PopularTable
		},
		methods: {
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				return (weekday === 0 || weekday === 6 || date > today);
			},
			onDatePicked() {
				this.load_popular_table_data();
			},
			show_kline(symbol_code) {
				this.symbol_code = symbol_code;
			},
			load_popular_table_data() {
				this.isBusy = true;
				const url = '/v3/open/sentiment/media/ths2/top?date1=' + this.date1 + '&top_n=100';
				request_zzquant({
					url: url
				}).then((resp1) => {
					this.items = resp1.data.data || [];
					this.isBusy = false;
				}).catch(err => {
					console.error("Load popular table data error:", err);
					this.items = [];
					this.isBusy = false;
				});
			}
		}
	}
</script>

<style scoped>
</style>
